import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './WrapArea.less';
import * as Selectors from '../reducers/selectors';
import { Group, Layer, Line, Stage } from 'react-konva';
import SpineHelper from '../helpers/SpineHelper';
import PropTypes from 'prop-types';
import { CanvasUtils } from '../utils/CanvasUtils';
import DustJacketHelper from '../helpers/DustJacketHelper';
import PicabooConstants from '../common/PicabooConstants';
import CoverOverlayText from './CoverOverlayText';

class WrapArea extends Component {
  constructor(props) {
    super(props);
    this.horizontalWrap = 0;
    this.verticalWrap = 0;
    this.cornerRadius = 0;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps != this.props || nextState != this.state;
  }

  componentDidMount() {
    if (this.refs.wrapCanvas != undefined) {
      this.drawWrap();
    }
  }

  componentDidUpdate() {
    if (this.refs.wrapCanvas != undefined) {
      this.drawWrap();
    }
  }

  drawWrap() {
    let ctx = this.refs.wrapCanvas.getContext('2d');
    let pageWidth = this.refs.wrapCanvas.width;
    let pageHeight = this.refs.wrapCanvas.height;
    let horizontalWrap = this.horizontalWrap;
    let verticalWrap = this.verticalWrap;
    let radius = this.cornerRadius;
    let fillColor = 'rgba(255,255,255,0.7)'; // Story http://teampulse.picaboo.com/view#/583 - make all .7 now - was: this.props.wrap.get('showLines') ? 'rgba(255,255,255,0.7)' : 'rgba(239,239,239,0.9)';

    ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, pageWidth, pageHeight);
    ctx.fillStyle = fillColor;
    ctx.fillRect(0, 0, pageWidth, pageHeight);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(255,255,255,1.0)';

    if (isNaN(radius) || radius === 0) {
      let x = horizontalWrap;
      let y = verticalWrap;
      let width = pageWidth - horizontalWrap * 2;
      let height = pageHeight - verticalWrap * 2;
      ctx.fillRect(x, y, width, height);
    } else {
      CanvasUtils.roundRect(
        ctx,
        horizontalWrap,
        verticalWrap,
        pageWidth - horizontalWrap * 2,
        pageHeight - verticalWrap * 2,
        radius,
        true,
        false,
      );
    }
  }

  render() {
    if (!this.props.wrap.get('showWrap')) {
      return null;
    }

    let leftSpine = 0;
    let spineWidth = 0;
    let outerAdjustment = 0;
    let dustJacketFlapWidth = 0;

    let { pageWidth, pageHeight, containerWidth, containerHeight } = this.props;

    pageWidth = Math.ceil(pageWidth);
    pageHeight = Math.ceil(pageHeight);
    containerWidth = Math.ceil(containerWidth);
    containerHeight = Math.ceil(containerHeight);

    const widthBase = Math.max(pageWidth, containerWidth);
    const heightBase = Math.max(pageHeight, containerHeight);

    let leftPageEdge = (widthBase - pageWidth) / 2;
    let topPageEdge = (heightBase - pageHeight) / 2;

    if (this.props.wrap.get('showSpine')) {
      let spineWidthCurrent = SpineHelper.calculateSpineWidth(
        pageWidth,
        this.props.metadata.get('numPages'),
        this.props.metadata.get('subtype'),
        this.props.metadata.get('style'),
        this.props.productInfo,
      );
      let spineWidthMax = SpineHelper.calculateMaxSpineWidth(
        pageWidth,
        this.props.metadata.get('subtype'),
        this.props.metadata.get('style'),
        this.props.productInfo,
      );
      spineWidth = spineWidthCurrent;

      leftSpine = (pageWidth - spineWidth) / 2;
      outerAdjustment = this.props.productInfo.get('dustJacket')
        ? 0
        : (spineWidthMax - spineWidthCurrent) / 2;

      if (this.props.productInfo.get('dustJacket')) {
        dustJacketFlapWidth = DustJacketHelper.calculateDustJacketFlapWidth(
          pageWidth,
          this.props.metadata.get('numPages'),
          this.props.metadata.get('subtype'),
          this.props.productInfo,
        );
      }
    }

    let hw = this.props.wrap.get('horizontalWrap');
    this.horizontalWrap = hw * pageWidth + leftPageEdge;
    let vw = this.props.wrap.get('verticalWrap');
    this.verticalWrap = vw * pageWidth + topPageEdge;
    this.cornerRadius = this.props.productInfo.get('cornerRadius') * pageWidth;

    const spineStrokeColor = PicabooConstants.COLORS.SPINE_STROKE_COLOR;
    const dustFlapStrokeColor = PicabooConstants.COLORS.DUSTFLAP_STROKE_COLOR;
    const strokeColor = PicabooConstants.COLORS.SAFETY_COLOR.STROKE_COLOR;
    const strokeTransparency =
      PicabooConstants.COLORS.SAFETY_COLOR.STROKE_TRANSPARENCY;
    const safetyStrokeColor =
      PicabooConstants.COLORS.SAFETY_COLOR.SAFETY_STROKE_COLOR;
    const safetyStrokeTransparency =
      PicabooConstants.COLORS.SAFETY_COLOR.SAFETY_STROKE_TRANSPARENCY;
    const wrapStrokeColor =
      PicabooConstants.COLORS.SAFETY_COLOR.WRAP_STROKE_COLOR;
    const wrapStrokeTransparency =
      PicabooConstants.COLORS.SAFETY_COLOR.WRAP_STROKE_TRANSPARENCY;

    return (
      <>
        <div className={styles.coverWrap}>
          {!this.props.reviewMode && (
            <Stage
              width={widthBase + 2}
              height={heightBase + 2}
              style={{ position: 'absolute' }}
            >
              <Layer>
                {this.props.settings.get('showSafety') && (
                  <Group>
                    {/* Top Safety Zone */}
                    <Line
                      points={[
                        this.horizontalWrap + outerAdjustment,
                        this.verticalWrap / 2,
                        pageWidth - this.horizontalWrap - outerAdjustment,
                        this.verticalWrap / 2,
                      ]}
                      strokeWidth={this.verticalWrap}
                      stroke={safetyStrokeColor}
                      opacity={safetyStrokeTransparency}
                    />
                    {/* Bottom Safety Zone */}
                    <Line
                      points={[
                        this.horizontalWrap + outerAdjustment,
                        pageHeight - this.verticalWrap / 2,
                        pageWidth - this.horizontalWrap - outerAdjustment,
                        pageHeight - this.verticalWrap / 2,
                      ]}
                      strokeWidth={this.verticalWrap}
                      stroke={safetyStrokeColor}
                      opacity={safetyStrokeTransparency}
                    />
                    {/* Left Safety Zone */}
                    <Line
                      points={[
                        this.horizontalWrap / 2 + outerAdjustment,
                        0,
                        this.horizontalWrap / 2 + outerAdjustment,
                        pageHeight,
                      ]}
                      strokeWidth={this.horizontalWrap}
                      stroke={safetyStrokeColor}
                      opacity={safetyStrokeTransparency}
                    />
                    {/* Right Safety Zone */}
                    <Line
                      points={[
                        pageWidth - this.horizontalWrap / 2 - outerAdjustment,
                        0,
                        pageWidth - this.horizontalWrap / 2 - outerAdjustment,
                        pageHeight,
                      ]}
                      strokeWidth={this.horizontalWrap}
                      stroke={safetyStrokeColor}
                      opacity={safetyStrokeTransparency}
                    />
                    {/* Left Wrap Zone */}
                    <Line
                      points={[
                        outerAdjustment / 2,
                        0,
                        outerAdjustment / 2,
                        pageHeight,
                      ]}
                      strokeWidth={outerAdjustment}
                      stroke={wrapStrokeColor}
                      opacity={wrapStrokeTransparency}
                    />
                    {/* Right Wrap Zone */}
                    <Line
                      points={[
                        pageWidth - outerAdjustment / 2,
                        0,
                        pageWidth - outerAdjustment / 2,
                        pageHeight,
                      ]}
                      strokeWidth={outerAdjustment}
                      stroke={wrapStrokeColor}
                      opacity={wrapStrokeTransparency}
                    />
                    {/* Crop Line */}
                    <Line
                      points={[
                        this.horizontalWrap + outerAdjustment,
                        this.verticalWrap,
                        pageWidth - this.horizontalWrap - outerAdjustment,
                        this.verticalWrap,
                        pageWidth - this.horizontalWrap - outerAdjustment,
                        pageHeight - this.verticalWrap,
                        this.horizontalWrap + outerAdjustment,
                        pageHeight - this.verticalWrap,
                        this.horizontalWrap + outerAdjustment,
                        this.verticalWrap,
                      ]}
                      strokeWidth={1}
                      stroke={strokeColor}
                      lineJoin={'rect'}
                      lineCap={'rect'}
                      opacity={strokeTransparency}
                      dash={[2, 2]}
                    />
                  </Group>
                )}
                {!this.props.reviewMode && this.props.wrap.get('showSpine') && (
                  <Group>
                    {/* Left edge of spine */}
                    <Line
                      points={[
                        leftSpine,
                        this.verticalWrap,
                        leftSpine,
                        pageHeight - this.verticalWrap,
                      ]}
                      strokeWidth={1}
                      stroke={spineStrokeColor}
                      lineJoin={'rect'}
                      lineCap={'rect'}
                      dash={[2, 2]}
                    />
                    {/* Right edge of spine */}
                    <Line
                      points={[
                        leftSpine + spineWidth,
                        this.verticalWrap,
                        leftSpine + spineWidth,
                        pageHeight - this.verticalWrap,
                      ]}
                      strokeWidth={1}
                      stroke={spineStrokeColor}
                      lineJoin={'rect'}
                      lineCap={'rect'}
                      dash={[2, 2]}
                    />
                  </Group>
                )}
                {this.props.wrap.get('showSpine') &&
                  this.props.productInfo.get('dustJacket') && (
                    <Group>
                      {/* Left Flap Fold */}
                      <Line
                        points={[
                          dustJacketFlapWidth,
                          this.verticalWrap,
                          dustJacketFlapWidth,
                          pageHeight - this.verticalWrap,
                        ]}
                        strokeWidth={2}
                        stroke={dustFlapStrokeColor}
                        lineJoin={'rect'}
                        lineCap={'rect'}
                        opacity={0.8}
                      />
                      {/* Right Flap Fold */}
                      <Line
                        points={[
                          pageWidth - dustJacketFlapWidth,
                          pageHeight - this.verticalWrap,
                          pageWidth - dustJacketFlapWidth,
                          this.verticalWrap,
                        ]}
                        strokeWidth={2}
                        stroke={dustFlapStrokeColor}
                        lineJoin={'rect'}
                        lineCap={'rect'}
                        opacity={0.8}
                      />
                    </Group>
                  )}
              </Layer>
            </Stage>
          )}
        </div>
        {this.props.labelVisible && (
          <CoverOverlayText
            width={pageWidth}
            outerAdjustment={outerAdjustment}
            pageWidth={pageWidth}
            pageHeight={pageHeight}
            verticalWrap={this.verticalWrap}
            horizontalWrap={this.horizontalWrap}
            isCover={this.props.productInfo.get('isCover')}
            t={this.props.t}
          />
        )}
      </>
    );
  }
}

WrapArea.propTypes = {
  pageWidth: PropTypes.number.isRequired,
  pageHeight: PropTypes.number.isRequired,
  containerWidth: PropTypes.number.isRequired,
  containerHeight: PropTypes.number.isRequired,
  labelVisible: PropTypes.bool.isRequired,
  wrap: PropTypes.object.isRequired,
  metadata: PropTypes.object.isRequired,
  productInfo: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  editorDim: PropTypes.object.isRequired,
  reviewMode: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  productInfo: Selectors.productInfo(state),
  metadata: Selectors.projectMetadataSelector(state),
  wrap: Selectors.wrapSelector(state),
  selectedSize: Selectors.selectedSize(state),
  settings: Selectors.settings(state),
}))(WrapArea);
